import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { ApiResponse, FavouriteDefinition, FavouriteResult } from 'app/types-shared';
import { endpoint } from './constants';

export const api = {
  executeCaseTableViewReport: async (favourite: FavouriteDefinition, startIndex: number, maxResults: number):
    Promise<FavouriteResult & { messages: Record<string, string> }> => {
    const response = await new RemoteData(endpoint.caseTableView)
      .resource<Response>()
      .filter({
        startIndex,
        maxResults

      })
      .create(favourite, false);
    const json = await response.json();
    return json.data;
  },

  getCaseTableViewSingleSupplierUrl: async (id: number): Promise<string> => {
    const response = await new RemoteData(endpoint.getExternalUrl(id))
      .resource<ApiResponse<{urlTemplate: string}>>().single();
     
    return await response.data.urlTemplate;
  }
};
